import React from "react";

const Opportunities = ({ data }) => {
  return (
    <section>
      <div className="container pt-lg-16 mb-lg-16 pt-11 mb-11 ">
        <div className="row mb-lg-10 mb-11">
          {/* First Feature Block */}
          <div className="col-lg-6 col-md-12">
            <div className="feature-card">
            <div className="d-flex mb-6">
                <span className="zg-label bg-purple text-black me-2">04</span>
                <span className="zg-label bg-purple text-black">Use</span>
              </div>
              <h2 className="h3 mb-6 rm-title">Unlock the full potential of your Bitcoin with Rootstock</h2>
              <p className="mb-6 rm-md-text">
              Maximize your Bitcoin earnings with Rootstock. Learn how to earn yield, join a liquidity pool or get a loan using your Bitcoin as collateral. With an ecosystem of more than 150 partners, every DeFi use case is possible on Bitcoin.
              </p>
              <a
                href="/ecosystem"
                className="btn-outline-white btn-lg btn"
              >
                Explore the Ecosystem
              </a>
            </div>
          </div>

          {/* Second Feature Block */}
          <div className="col-lg-6 col-md-12">
            <div className="feature-card">
            <div className="d-flex mb-6">
                <span className="zg-label bg-green text-black me-2">05</span>
                <span className="zg-label bg-green text-black">Develop</span>
              </div>
              <h2 className="h3 mb-6 rm-title">
                Build on the world’s most secure Bitcoin sidechain
              </h2>
              <p className="mb-6 rm-md-text">
              Build apps secured by Bitcoin today with Rootstock. 
              EVM compatible and supported by the leading developer tools;
               oracles, indexers, Rootstock is the most advanced and complete 
               infrastructure for building on Bitcoin.
              </p>
              <a
                href="/develop"
                className="btn-outline-white btn-lg btn"
              >
                Build on Bitcoin with Rootstock
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Opportunities;
